import React, { FC, ReactNode, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import translate from '@translate';
import Select, { OptionType } from '../../components/Select';
import Typography from '../../components/Typography';
import Button from '../../components/Button';

export interface ChangeStatusDialogStatePropsType {
    title: string;
    action?: (data?: any, cancelReason?: string | null) => void;
    onCancel?: () => void;
    disabled?: boolean;
    content?: string | ReactNode;
    pickCancelReasonContent?: string | ReactNode;
    options?: OptionType[];
    optionsValue?: any;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    showCancelReason?: boolean;
}

export interface ChangeStatusDialogPropsType {
    title: string | ReactNode;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    action?: (data?: any, cancelReason?: string | null) => void;
    onCancel?: () => void;
    onClose: () => void;
    disabled?: boolean;
    content?: string | ReactNode;
    pickCancelReasonContent?: string | ReactNode;
    options?: OptionType[];
    cancelReasonOptions: OptionType[];
    optionsValue?: any;
    simpleContent?: string | ReactNode;
    showCancelReason?: boolean;
}

const ChangeStatusDialog: FC<ChangeStatusDialogPropsType> = (props) => {
    const [optionsValue, setOptionsValue] = useState<any>(props.optionsValue || null);
    const [cancelReason, setCancelReason] = useState<any>(null);
    const [data, setData] = useState<any>({});
    const shouldSelectCancelReason = props.showCancelReason && optionsValue === 'canceled';
    const content = (
        <>
            <Typography component="div">{props.content}</Typography>
            {props.options && (
                <Select
                    options={props.options}
                    value={optionsValue}
                    onChange={setOptionsValue}
                    fullWidth
                    required
                />
            )}
            {shouldSelectCancelReason && (
                <div>
                    <Typography component="div">{props.pickCancelReasonContent}</Typography>
                    <Select
                        options={props.cancelReasonOptions}
                        value={cancelReason}
                        onChange={setCancelReason}
                        fullWidth
                        required
                    />
                </div>
            )}
        </>
    )
    ;

    const handleOk = () => {
        if (props.action) {
            props.action(optionsValue, cancelReason);
        }
        props.onClose();
    };

    const handleCancel: any = () => {
        if (props.onCancel) {
            props.onCancel();
        }
        props.onClose();
    };

    return (
        <Dialog maxWidth={props.maxWidth || 'xs'} open>
            <DialogTitle id="confirmation-dialog-title">{props.title}</DialogTitle>
            <DialogContent dividers>
                {props.simpleContent}
                {content}
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleCancel}>
                    {translate('confirmDialog.cancel')}
                </Button>
                {props.action && (
                    <Button variant="contained" onClick={handleOk}
                            disabled={props.disabled || (props.showCancelReason && !cancelReason && shouldSelectCancelReason)}>
                        {translate('confirmDialog.ok')}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ChangeStatusDialog;
